import { SENTRY_LOG, simpleLogger } from '@/services/sentry';
import { requestRestart } from '@/stores/device';
import { createLogger } from '@/utils/logger';
import { estimateStorageQuota } from '@/utils/storage';

const storageLogger = createLogger('Storage');

export async function reportStorageError(
  error: unknown,
  key: string,
  operation: string,
  driver = 'unknown',
): Promise<void> {
  const attributes = {
    key,
    operation,
    driver,
  };

  if (error instanceof Error && error.message === 'UnknownError') {
    storageLogger.fatal(error, attributes);
    requestRestart();
  } else {
    const estimate = await estimateStorageQuota();
    if (estimate) Object.assign(attributes, estimate);
    storageLogger.warn(error, attributes);
  }

  return simpleLogger({
    name: SENTRY_LOG.STORAGE,
    requestAttributes: attributes,
  });
}
